import { TooltipAccountIcon } from './TooltipAccountIcon';

/**
 * author: Google
 * id CA087C29-F27F-4DBE-8617-1369C18DF51D
 * name tooltip-account
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/tooltip-account.svg
 * tags
 * - Account / User 
 * - Tooltip 
 */
export const TooltipPersonIcon = TooltipAccountIcon;
export default TooltipPersonIcon